<template>
<div>
  <modal name="turpe-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_turpe"></span>
  </modal>
  <modal name="buying_price-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_buying_price"></span>
  </modal>
  <!--
  <modal name="iwb-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_iwb"></span>
  </modal>
  -->
  <modal name="free-sale-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_free_sale"></span>
  </modal>
  <modal name="autoconsumption-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_autoconsumption"></span>
  </modal>
  <modal name="overlay-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_overlay"></span>
  </modal>
  <modal name="surplus-sale-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_surplus_sale"></span>
  </modal>
  
  <div v-if="isError" class="error">
    <center>
      <div v-if="!form_electricity_price_ok">Erreur dans l'onglet autoconsommation</div>
      <div v-if="!form_power_ok">Erreur dans l'onglet caractéristiques de l'installation</div>
      <div v-if="!form_investment_ok">Erreur dans l'onglet investissement</div>
    </center>
  </div>
  <div v-else>
    <div v-if="isLoading" class="loading"><center><img src="/static/img/loading.gif" alt="Chargement en cours…"></center></div>
    <div v-else>
      <div class="best-yield">
        <h2>Meilleure solution économique</h2>
        
        <h3>Résultat sur 20 ans</h3>
        <span class="sub-title">(ventes + économies sur la facture - investissement)</span>
        
        <div class="grid-x grid-margin-x">
          
          <div class="small-12 medium-6 large-4 cell">
            
            <div class="callout price-callout">
              
              <div class="grid-x grid-margin-x">
                <div class="small-2 medium-4 cell">
                  <div :class="best.method">
                    <i :class="best.method"></i>
                  </div>
                </div>
                <div class="small-10 medium-8 cell">
                  {{ best.name }}&nbsp;:
                  <button aria-label="Aide" class="modal-helper" @click="callModal(best.helper)"><i class="fas fa-question-circle"></i></button>
                  <div v-if="best.net_income_20_years!='-'" class="price">{{ best.net_income_20_years }}€</div>
                  <div class="price-message">{{ best.income_20_years_message }}</div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="small-12 medium-6 large-8 cell">
            <span v-html="best.explanation_text">{{ best.explanation_text }}</span>
          </div>
          
        </div>
        
      </div>
      
      <div class="callout other-solutions">
        <div class="grid-x grid-margin-x">
          <div class="small-10 cell">
            <h2>Autres solutions</h2>
          </div>
          <div class="small-2 cell text-right">
            <a class="button-plus"  v-on:click="toggleOtherSolutions">
              <span v-bind:class="{ hide: showOtherSolutions }"><i class="fas fa-plus-square" title="Voir les autres solutions"></i></span>
              <span v-bind:class="{ hide: hideOtherSolutions }"><i class="fas fa-minus-square" title="Cacher les autres solutions"></i></span>
            </a>
          </div>
        </div>
      </div>
      
      <div v-bind:class="{ hide: hideOtherSolutions }" id="other-solution">
        <div class="grid-x grid-margin-x no-callout">
          
          <div v-for="item in all" v-if="item.method != best.method" class="small-12 medium-6 large-4 cell" v-bind:class="{'large-8': renderTwoColumns(item.method), 'large-4': !renderTwoColumns(item.method)}">
            <div class="callout price-callout">
              <div class="grid-x grid-margin-x">
                <div class="small-2 cell"  v-bind:class="{'medium-2': renderTwoColumns(item.method), 'medium-4': !renderTwoColumns(item.method)}">
                  <div :class="item.method">
                    <i :class="item.method"></i>
                  </div>
                </div>
                <div class="small-10 cell"  v-bind:class="{'medium-10': renderTwoColumns(item.method), 'medium-8': !renderTwoColumns(item.method)}">
                  {{ item.name }}&nbsp;:
                  <button aria-label="Aide" class="modal-helper" @click="callModal(item.helper)"><i class="fas fa-question-circle"></i></button>
                  <div v-if="item.net_income_20_years!='-'" class="price">{{ item.net_income_20_years_int }}€</div>
                  <div class="price-message">{{ item.income_20_years_message }}</div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      
      <highcharts :options="options" ref="highcharts" :series="chart_data"></highcharts>
      
      
      <div class="callout details">
        <div class="grid-x grid-margin-x">
          <div class="small-10 cell">
            <h2>Détails</h2>
          </div>
          <div class="small-2 cell text-right">
            <a class="button-plus"  v-on:click="toggleDetail">
              <span v-bind:class="{ hide: showDetails }"><i class="fas fa-plus-square" title="Voir le détail des résultats"></i></span>
              <span v-bind:class="{ hide: hideDetails }"><i class="fas fa-minus-square" title="Cacher le détail des résultats"></i></span>
            </a>
          </div>
        </div>
      </div>
      
      <div v-bind:class="{ hide: hideDetails }" id="details">
        
        <table class="responsive-card-table unstriped">
          <thead>
            <tr>
              <th></th>
              <!--<th class="text-center"><i class="iwb"></i>Vente de la totalité IAB&nbsp;<button aria-label="Aide" class="modal-helper" @click="showModalIWB"><i class="fas fa-question-circle"></i></button></th>-->
              <th class="text-center"><i class="overlay"></i>Vente de la totalité sur-imposition&nbsp;<button aria-label="Aide" class="modal-helper" @click="showModalOverlay"><i class="fas fa-question-circle"></i></button></th>
              <th class="text-center"><i class="surplus_sale"></i>Autoconsommation partielle vente du surplus&nbsp;<button aria-label="Aide" class="modal-helper" @click="showModalSurplusSale"><i class="fas fa-question-circle"></i></button></th>
              <th class="text-center"><i class="free_sale"></i>Autoconsommation partielle cession gratuite&nbsp;<button aria-label="Aide" class="modal-helper" @click="showModalFreeSale"><i class="fas fa-question-circle"></i></button></th>
              <th class="text-center"><i class="autoconsumption"></i>Autoconsommation totale&nbsp;<button aria-label="Aide" class="modal-helper" @click="showModalAutoconsumption"><i class="fas fa-question-circle"></i></button></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Electricité vendue</td>
              <!--<td data-label="Vente de la totalité IAB" class="text-right">{{ result_iwb.sold_production }}<span class="fine">&nbsp;</span>kWh</td>-->
              <td data-label="Vente de la totalité sur-imposition" class="text-right">{{ result_overlay.sold_production }}<span class="fine">&nbsp;</span>kWh</td>
              <td data-label="Autoconsommation partielle vente du surplus" class="text-right">{{ result_surplus_sale.sold_production }}<span class="fine">&nbsp;</span>kWh</td>
              <td data-label="Autoconsommation partielle cession gratuite" class="text-right">{{ result_free_sale.sold_production }}<span class="fine">&nbsp;</span>kWh</td>
              <td data-label="Autoconsommation totale" class="text-right">{{ result_autoconsumption.sold_production }}<span class="fine">&nbsp;</span>kWh</td>
            </tr>
            <tr>
              <td>Electricité autoconsommée</td>
              <!--<td data-label="Vente de la totalité IAB" class="text-right">{{ result_iwb.autoconsumption }}<span class="fine">&nbsp;</span>kWh</td>-->
              <td data-label="Vente de la totalité sur-imposition" class="text-right">{{ result_overlay.autoconsumption }}<span class="fine">&nbsp;</span>kWh</td>
              <td data-label="Autoconsommation partielle vente du surplus" class="text-right">{{ result_surplus_sale.autoconsumption }}<span class="fine">&nbsp;</span>kWh</td>
              <td data-label="Autoconsommation partielle cession gratuite" class="text-right">{{ result_free_sale.autoconsumption }}<span class="fine">&nbsp;</span>kWh</td>
              <td data-label="Autoconsommation totale" class="text-right">{{ result_autoconsumption.autoconsumption }}<span class="fine">&nbsp;</span>kWh</td>
            </tr>
            <tr>
              <td>Tarif d'achat PV <!--{{ result_overlay.purchase_price_name }}&nbsp;--><button aria-label="Aide" class="modal-helper" @click="showModalPrices"><i class="fas fa-question-circle"></i></button></td>
              <!--
              <td data-label="Vente de la totalité IAB" class="text-right">{{ result_iwb.purchase_price }}<span class="fine">&nbsp;</span>c€/kWh</td>
              -->
              <td data-label="Vente de la totalité sur-imposition" class="text-right">{{ result_overlay.purchase_price }}<span class="fine">&nbsp;</span>c€/kWh</td>
              <td data-label="Autoconsommation partielle vente du surplus" class="text-right">{{ result_surplus_sale.purchase_price }}<span class="fine">&nbsp;</span>c€/kWh</td>
              <td data-label="Autoconsommation partielle cession gratuite" class="text-right">{{ result_free_sale.purchase_price }}<span class="fine">&nbsp;</span>c€/kWh</td>
              <td data-label="Autoconsommation totale" class="text-right">{{ result_autoconsumption.purchase_price }}<span class="fine">&nbsp;</span>c€/kWh</td>
            </tr>
            <tr>
              <td>Prime à l'investissement</td><!--'-->
              <!--<td data-label="Vente de la totalité IAB" class="text-right">{{ result_iwb.investment_prime }}<span class="fine">&nbsp;</span>€</td>-->
              <td data-label="Vente de la totalité sur-imposition" class="text-right">{{ result_overlay.investment_prime }}<span class="fine">&nbsp;</span>€</td>
              <td data-label="Autoconsommation partielle vente du surplus" class="text-right">{{ result_surplus_sale.investment_prime }}<span class="fine">&nbsp;</span>€</td>
              <td data-label="Autoconsommation partielle cession gratuite" class="text-right">{{ result_free_sale.investment_prime }}<span class="fine">&nbsp;</span>€</td>
              <td data-label="Autoconsommation totale" class="text-right">{{ result_autoconsumption.investment_prime }}<span class="fine">&nbsp;</span>€</td>
            </tr>
            <tr>
              <td>TURPE&nbsp;<button aria-label="Aide" class="modal-helper" @click="showModalTurpe"><i class="fas fa-question-circle"></i></button></td>
              <!--<td data-label="Vente de la totalité IAB" class="text-right">{{ parseInt(result_iwb.turpe_rate) }}<span class="fine">&nbsp;</span>€TTC/an</td>-->
              <td data-label="Vente de la totalité sur-imposition" class="text-right">{{ parseInt(result_overlay.turpe_rate) }}<span class="fine">&nbsp;</span>€TTC/an</td>
              <td data-label="Autoconsommation partielle vente du surplus" class="text-right">{{ parseInt(result_surplus_sale.turpe_rate) }}<span class="fine">&nbsp;</span>€TTC/an</td>
              <td data-label="Autoconsommation partielle cession gratuite" class="text-right"><span v-if="isNaN(result_free_sale.turpe_rate)">{{ result_free_sale.turpe_rate }}</span><span v-else>{{ parseInt(result_free_sale.turpe_rate) }}<span class="fine">&nbsp;</span>€TTC/an</span></td>
              <td data-label="Autoconsommation totale" class="text-right">{{ parseInt(result_autoconsumption.turpe_rate) }}<span class="fine">&nbsp;</span>€TTC/an</td>
            </tr>
            
            <tr>
              <td>Gain annuel année 1 (vente + économies sur la facture)</td>
              <!--
              <td v-if="noIAB" data-label="Vente de la totalité IAB" class="text-right">-</td>
              <td v-if="!noIAB" data-label="Vente de la totalité IAB" class="text-right">{{ parseInt(result_iwb.income_1_year) }}<span class="fine">&nbsp;</span>€</td>
              -->
              <td data-label="Vente de la totalité sur-imposition" class="text-right">{{ parseInt(result_overlay.income_1_year) }}<span class="fine">&nbsp;</span>€</td>
              <td data-label="Autoconsommation partielle vente du surplus" class="text-right">{{ parseInt(result_surplus_sale.income_1_year) }}<span class="fine">&nbsp;</span>€</td>
              <td v-if="noFreeSale" data-label="Autoconsommation partielle cession gratuite" class="text-right">-</td>
              <td v-if="!noFreeSale" data-label="Autoconsommation partielle cession gratuite" class="text-right">{{ parseInt(result_free_sale.income_1_year) }}<span class="fine">&nbsp;</span>€</td>
              <td data-label="Autoconsommation totale" class="text-right">{{ parseInt(result_autoconsumption.income_1_year) }}<span class="fine">&nbsp;</span>€</td>
            </tr>
            <tr class="strong">
              <td>Revenus sur 20 ans (vente + économies sur la facture)</td>
              <!--
              <td v-if="noIAB" data-label="Vente de la totalité IAB" class="text-right">{{ result_iwb.income_20_years_message }}</td>
              <td v-if="!noIAB" data-label="Vente de la totalité IAB" class="text-right">{{ parseInt(result_iwb.income_20_years) }}<span class="fine">&nbsp;</span>€ {{ result_iwb.income_20_years_message }}</td>
              -->
              <td data-label="Vente de la totalité sur-imposition" class="text-right">{{ parseInt(result_overlay.income_20_years) }}<span class="fine">&nbsp;</span>€ {{ result_overlay.income_20_years_message }}</td>
              <td data-label="Autoconsommation partielle vente du surplus" class="text-right">{{ parseInt(result_surplus_sale.income_20_years) }}<span class="fine">&nbsp;</span>€ {{ result_surplus_sale.income_20_years_message }}</td>
              <td v-if="noFreeSale" data-label="Autoconsommation partielle cession gratuite" class="text-right">{{ result_free_sale.income_20_years_message }}</td>
              <td v-if="!noFreeSale" data-label="Autoconsommation partielle cession gratuite" class="text-right">{{ result_free_sale.income_20_years }}<span class="fine">&nbsp;</span>€</td>
              <td data-label="Autoconsommation totale" class="text-right">{{ parseInt(result_autoconsumption.income_20_years) }}<span class="fine">&nbsp;</span>€<br> {{ result_autoconsumption.income_20_years_message }}</td>
            </tr>
            
            <tr class="strong">
              <td>Résultat sur 20 ans (vente + économies sur la facture - investissement total)</td>
              <!--
              <td v-if="noIAB"  data-label="Vente de la totalité IAB" class="text-right">-</td>
              <td v-if="!noIAB"  data-label="Vente de la totalité IAB" class="text-right">{{ parseInt(result_iwb.net_income_20_years) }}<span class="fine">&nbsp;</span>€</td>
              -->
              <td data-label="Vente de la totalité sur-imposition" class="text-right">{{ parseInt(result_overlay.net_income_20_years) }}<span class="fine">&nbsp;</span>€</td>
              <td data-label="Autoconsommation partielle vente du surplus" class="text-right">{{ parseInt(result_surplus_sale.net_income_20_years) }}<span class="fine">&nbsp;</span>€</td>
              <td v-if="noFreeSale" data-label="Autoconsommation partielle cession gratuite" class="text-right">{{ result_free_sale.net_income_20_years }}</td>
              <td v-if="!noFreeSale" data-label="Autoconsommation partielle cession gratuite" class="text-right">{{ parseInt(result_free_sale.net_income_20_years) }}<span class="fine">&nbsp;</span>€</td>
            <td data-label="Autoconsommation totale" class="text-right">{{ parseInt(result_autoconsumption.net_income_20_years) }}<span class="fine">&nbsp;</span>€</td>
          </tr>
        </tbody>
      </table>
      
    </div>
    
  </div>
  </div>
</div>
</template>


<script>
import Vue from 'vue';
import HighchartsVue from 'highcharts-vue';

Vue.use(HighchartsVue);
import {Chart} from 'highcharts-vue';

import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'

import apiClient from '@/api';

import _ from 'lodash'


var options = {
    credits: {
        enabled: false
    },
    title: {
        text: 'Bilan financier sur 20 ans',
        x: -20 //center
    },
    subtitle: {
        text: '(revenus - investissement), année par année',
        x: -20
    },
    xAxis: {
        title: {
            text: 'Années',
        }
    },
    yAxis: {
        title: {
            text: '€'
        },
        plotLines: [{
            value: 0,
            width: 1,
            color: '#808080'
        }]
    },
    tooltip: {
        valueSuffix: '€'
    },
    legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        borderWidth: 0
    },
    plotOptions: {
        series: {
            marker: {
                enabled: false
            },
        }
    },
    series: [
        // {
        //     name: 'Vente de la totalité intégration au bati',
        //     data: [],
        //     color: '#f18700',
        // },
        {
            name: 'Autoconsommation partielle cession gratuite',
            data: [],
            color: '#b6b2a9',
        },
        {
            name: 'Autoconsommation totale',
            data: [],
            color: '#bdde1b',
        },
        {
            name: 'Vente de la totalité sur-imposition',
            data: [],
            color: '#9d0a7d',
        },
        {
            name: 'Autoconsommation partielle vente du surplus',
            data: [],
            color: '#007ec5',
        }
    ]
};

export default {
    name: 'ShowResults',
    components: {
        'highcharts': Chart,
    },
    data () {
        return {
            isLoading: false,
            isError: true,
            hideDetails: true,
            hideOtherSolutions: true,
            // result_iwb: {},
            result_overlay: {},
            result_surplus_sale: {},
            result_free_sale: {},
            result_autoconsumption: {},
            financial: {},
            helper_buying_price: "",
            helper_turpe: "",
            // helper_iwb: "",
            helper_free_sale: "",
            helper_autoconsumption: "",
            helper_overlay: "",
            helper_surplus_sale: "",
            best: {},
            all: {},
            // Charts
            options: options,
            chart_data: [],
            
            debounced_getResults: null,
        };
    },
    computed: {
            ...mapFields(
                [
                    'productivity',
                    'autoconsumption',
                    'subscription',
                    'power',
                    'current_price',
                    'price_inflation_percent_for_5_years',
                    'price_inflation_percent_after_5_years',
                    // 'investment_iwb',
                    'investment_overlay',
                    'investment_surplus_sale',
                    'investment_free_sale',
                    'investment_autoconsumption',
                    'form_electricity_price_ok',
                    'form_power_ok',
                    'form_investment_ok',
                ],
            ),
        showOtherSolutions: function() {
            return !this.hideOtherSolutions;
        },
        showDetails: function() {
            return !this.hideDetails;
        },
        noFreeSale: function() {
            return this.result_free_sale.income_1_year == '-';
        },
        // noIAB: function() {
        //     return this.result_iwb.income_1_year == '-';
        // },
    },
    watch:{
        chart_data() { this.redraw(); },
        productivity: function () { this.call_debounced_getResults(this); },
        autoconsumption: function () { this.call_debounced_getResults(this); },
        subscription: function () { this.call_debounced_getResults(this); },
        power: function () { this.call_debounced_getResults(this); },
        current_price: function () { this.call_debounced_getResults(); },
        price_inflation_percent_for_5_years: function () { this.call_debounced_getResults(this); },
        price_inflation_percent_after_5_years: function () { this.call_debounced_getResults(this); },
        // investment_iwb: function () { this.call_debounced_getResults(this); },
        investment_overlay: function () { this.call_debounced_getResults(this); },
        investment_surplus_sale: function () { this.call_debounced_getResults(this); },
        investment_free_sale: function () { this.call_debounced_getResults(this); },
        investment_autoconsumption: function () { this.call_debounced_getResults(this); },
    },
    created: function() {
        this.debounced_getResults = _.debounce(this.getResults, 2000);
    },
    mounted: function() {
        this.call_debounced_getResults(this);
    },
    methods: {
        toggleOtherSolutions: function() {
            this.hideOtherSolutions = !this.hideOtherSolutions;
        },
        toggleDetail: function() {
            this.hideDetails = !this.hideDetails;
        },
        callModal: function(helper) {
            this[helper]();
        },
        showModalTurpe: function() {
            this.$modal.show('turpe-modal')
        },
        showModalPrices: function() {
            this.$modal.show('buying_price-modal')
        },
        // showModalIWB: function() {
        //     this.$modal.show('iwb-modal')
        // },
        showModalFreeSale: function() {
            this.$modal.show('free-sale-modal')
        },
        showModalAutoconsumption: function() {
            this.$modal.show('autoconsumption-modal')
        },
        showModalOverlay: function() {
            this.$modal.show('overlay-modal')
        },
        showModalSurplusSale: function() {
            this.$modal.show('surplus-sale-modal')
        },
        showModalPrices: function() {
            this.$modal.show('buying_price-modal')
        },
        renderTwoColumns: function(method) {
            if (method == 'free_sale') {
                return true;
            }
            return false;
        },
        
        call_debounced_getResults: function(obj) {
            if (obj == undefined) {
                obj = this;
            }
            if (this.debounced_getResults != null) {
                console.log('Calculate everything... debounce');
                this.debounced_getResults(this);
            }
        },
        getResults: function(obj) {
            console.log('Calculate everything... REALLY');
            if (
                this.form_investment_ok == true
                    && this.form_power_ok == true
                    && this.form_electricity_price_ok == true
            ) {
                this.isError = false;
                this.isLoading = true;

                apiClient.genericPost('/eval-rentability/compute-data/0/compute_rentability/',
                    {
                        id: 0,
                        productivity: obj.productivity,
                        autoconsumption: obj.autoconsumption / 100,
                        subscription: obj.subscription,
                        power: obj.power,
                        current_price: obj.current_price,
                        price_inflation_percent_for_5_years: obj.price_inflation_percent_for_5_years,
                        price_inflation_percent_after_5_years: obj.price_inflation_percent_after_5_years,
                        // investment_iwb: obj.investment_iwb || 0,
                        investment_overlay: obj.investment_overlay || 0,
                        investment_surplus_sale: obj.investment_surplus_sale || 0,
                        investment_free_sale: obj.investment_free_sale || 0,
                        investment_autoconsumption: obj.investment_autoconsumption || 0,
                    }
                ).then(
                    response => {
                        console.log('Got rentability', response);
                        
                        obj.isLoading = false;
                        // obj.result_iwb = response.iwb;
                        obj.result_overlay = response.overlay;
                        obj.result_surplus_sale = response.surplus_sale;
                        obj.result_free_sale = response.free_sale;
                        obj.result_autoconsumption = response.autoconsumption;
                        
                        obj.financial = response.financial;
                        obj.best = response.best;
                        obj.all = response.all;
                        obj.helper_turpe = response.helper_turpe;
                        obj.helper_buying_price = response.helper_buying_price;
                        
                        // obj.helper_iwb = response.helper_iwb;
                        obj.helper_free_sale = response.helper_free_sale;
                        obj.helper_autoconsumption = response.helper_autoconsumption;
                        obj.helper_overlay = response.helper_overlay;
                        obj.helper_surplus_sale = response.helper_surplus_sale;
                    
                    obj.chart_data = response.financial;
                }
            );
            }
            else {
                this.isError = true;
            }
        },  
        
        redraw: function(){
            var self = this;

            // Remove getters and setters from data
            var data = JSON.parse(JSON.stringify(this.chart_data));
            console.log("data before : ", data);
            
            Object.keys(data).reduce(function (data, key) {
                
                if (data["_" +  key] === data[key]) {
                    delete data["_" +  key];
                }
                return data;
                
            }, data);

            for (let i=0; i < data.length; i++) {
                var newdata = [];
                for (let val in data[i].data) {
                    newdata.push(parseInt(data[i].data[val]));
                }
                data[i].data = newdata;
            }
            console.log("data after : ", data);

            console.log(this.chart_data, this.$refs, data);

            Vue.nextTick(function() {
                var hc = self.$refs.highcharts;
                if (hc != undefined) {
                    hc.chart.update(
                        {
                            series: data,
                        }
                    );
                }
                else {
                    Vue.nextTick(function() {
                        console.log('REDRAW on nextTick', self.chart_data, self.$refs);
                        var hc = self.$refs.highcharts;
                        if (hc != undefined) {
                            hc.chart.update(
                                {
                                    series: data,
                                }
                            );
                        }
                    });
                }
            });
        },
    },      
}

</script>

<style scoped>
  div.other-solutions, div.details {
    margin-top: 3rem;
  }
  span.fine {
     font-size: 70%;
  }
  table, tr, td {
    border: 1px solid #ccc;
    border: 1px solid #f8f7f5;
  }
  th {
     background-color: #ff570c;
     color: #fff;
     border: 1px solid #fff;
     text-transform: uppercase;
     font-size: 70%;
     vertical-align: top;
  }
  th button {
      color: #fff;
      font-size: 1rem;
  }
  tr:nth-child(even) {
     background-color: #f0efed;
     background-color: #f8f7f5;
  }
  .price {
    font-family: "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
    font-size: 2.6rem;
    font-weight: bold;
    color: #fe5f01;
  }
  .price-message {
    font-weight: bold;
    color: #fe5f01;
  }
  div.callout.other-solutions h2 {
    margin-top: 0.6rem;
  }
  div.callout.other-solutions {
    padding-bottom: 0;
    border: none;
  }
  div.callout.details h2 {
    margin-top: 0.6rem;
  }
  div.callout.details {
    padding-bottom: 0;
    border: none;
  }
  div.callout.price-callout {
    background: white;
    border: none;
    min-height: 180px;
  }
  i.iwb, i.free_sale, i.autoconsumption, i.overlay, i.surplus_sale {
      font-size: 5rem;
      color: #253c4e;
      margin: 0;
  }
  i.autoconsumption {
      font-size: 4rem;
  }
  table i.iwb, table i.free_sale, table i.autoconsumption, table i.overlay, table i.surplus_sale {
      color: #fff;
      font-size: 2rem;
      margin-right: 4px;
      display: block;
  }
  table i.autoconsumption {
      font-size: 1.6rem;
      line-height: 2rem;
  }
  .button-plus {
    font-size: 2rem;
    margin-right: 1rem;
    top: -.5rem;
    position: relative;
  }
  .no-callout {
    padding-top: 0.8rem;
    background-color: #f8f7f5;
  }
  @media only screen and (max-width: 1024px) {
    .price {
      font-size: 2rem;
    }
  }
  @media only screen and (min-width: 0px) and (max-width: 639px) {
    .price {
      font-size: 1.2rem;
    }
  }
  @media only screen and (min-width: 0px) and (max-width: 939px) {
    table {
      font-size: 12px;
    }
    tr:nth-child(even) {
     background-color: #fff;
    }
    i.iwb, i.free_sale, i.autoconsumption, i.overlay, i.surplus_sale {
      font-size: 3rem;
    }

  }
  @media only screen and (max-width: 1100px) {
    #other-solution {
      font-size: 12px;
    }
    #other-solution div.price {
      font-size: 22px;
    }
    i.iwb, i.free_sale, i.autoconsumption, i.overlay, i.surplus_sale {
      font-size: 4rem;
    }
  }
  @media only screen and (max-width: 1500px) {
    table {
      font-size: 11.5px;
    }
  }
  @media only screen and (max-width: 1424px) {
    table {
      font-size: 11px;
    }
  }
  @media only screen and (max-width: 1224px) {
    table {
      font-size: 10px;
    }
  }
  #details, #other-solution {
      -moz-animation-name: fadeIn;
      -webkit-animation-name: fadeIn;
      -ms-animation-name: fadeIn;
      animation-name: fadeIn;
      -moz-animation-duration: 1s;
      -webkit-animation-duration: 1s;
      -ms-animation-duration: 1s;
      animation-duration: 1s;
      -moz-animation-timing-function: ease-in-out;
      -webkit-animation-timing-function: ease-in-out;
      -ms-animation-timing-function: ease-in-out;
      animation-timing-function: ease-in-out;
      -moz-animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      -ms-animation-fill-mode: forwards;
      animation-fill-mode: forwards; 
  }
  #details.hide, #other-solution.hide {
      -moz-animation-name: fadeOut;
      -webkit-animation-name: fadeOut;
      -ms-animation-name: fadeOut;
      animation-name: fadeOut;
  }
  @-moz-keyframes fadeIn { 0% { opacity: 0; visibility: hidden; } 100% { opacity: 1; visibility: visible; }}
  @-webkit-keyframes fadeIn { 0% { opacity: 0; visibility: hidden; } 100% { opacity: 1; visibility: visible; }}
  @-ms-keyframes fadeIn { 0% { opacity: 0; visibility: hidden; } 100% { opacity: 1; visibility: visible; }}
  @-keyframes fadeIn { 0% { opacity: 0; visibility: hidden; } 100% { opacity: 1; visibility: visible; }}

  @-moz-keyframes fadeOut { 0% { opacity: 1; visibility: visible; }  100% { opacity: 0; visibility: hidden; }} 
  @-webkit-keyframes fadeOut { 0% { opacity: 1; visibility: visible; }  100% { opacity: 0; visibility: hidden; }} 
  @-ms-keyframes fadeOut { 0% { opacity: 1; visibility: visible; } 100% { opacity: 0; visibility: hidden; }} 
  @-keyframes fadeOut { 0% { opacity: 1; visibility: visible; } 100% { opacity: 0; visibility: hidden;  }} 
</style>



// WEBPACK FOOTER //
// src/components/show_results.vue